/**
 * Runs a callback after a delay
 * @param callback The function to call
 * @param delay The amount of milliseconds to wait
 */
export default function (callback: () => void, delay: number) {
  setTimeout(callback, delay)
}
